var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.293031 9.70643C0.10556 9.5189 0.000244141 9.2646 0.000244141 8.99943C0.000244141 8.73427 0.10556 8.47996 0.293031 8.29243L3.58603 4.99943L0.293031 1.70643C0.110873 1.51783 0.0100779 1.26523 0.0123563 1.00303C0.0146347 0.740833 0.119804 0.49002 0.305212 0.304612C0.49062 0.119204 0.741433 0.014035 1.00363 0.0117566C1.26583 0.00947813 1.51843 0.110273 1.70703 0.292431L5.70703 4.29243C5.8945 4.47996 5.99982 4.73427 5.99982 4.99943C5.99982 5.2646 5.8945 5.5189 5.70703 5.70643L1.70703 9.70643C1.5195 9.8939 1.26519 9.99922 1.00003 9.99922C0.734866 9.99922 0.480558 9.8939 0.293031 9.70643Z",
    fill: "#18181B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.6d6b1d348ce5ef9f39be1723851d331f.svg";
export { ForwardRef as ReactComponent };